import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router-dom';

import { NotFound } from 'pages/error/NotFound';
import { AccessDenied } from 'pages/front/AccessDenied';
import { Home } from 'pages/front/Home';

import { MainPanel, FrontContentWrapper } from './styledComponents';

export const ContentWrapper = () => {
  return (
    <MainPanel>
      <Helmet>
        <title>Rabbit</title>
      </Helmet>
      <FrontContentWrapper>
        <Switch>
          <Route exact path='/home' component={Home} />
          <Route
            exact
            path='/home/user/inactive'
            render={() => {
              return (
                <AccessDenied message='Your account is not active. Please contact an administrator' />
              );
            }}
          />
          <Route component={NotFound} />
        </Switch>
      </FrontContentWrapper>
    </MainPanel>
  );
};
